import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deepCopy } from 'deep-copy-ts';
import { WindowService } from 'src/app/shared/components/window/window.service';
import {CabosAlimentacaoInterno, MitraNetworkParameters} from '../state/network-parameters.model.generated';
import { createSimulation, Simulation } from '../state/simulation.model';
import { SimulationService } from '../state/simulation.service';
import {OpticalCableComponent} from './optical-cable/optical-cable.component';

@Component({
  selector: 'app-simulation-architecture',
  templateUrl: './simulation-architecture.component.html',
  styleUrls: ['./simulation-architecture.component.scss']
})
export class SimulationArchitectureComponent implements OnInit {

  @ViewChild('opticalCableComponent')
  opticalCableComponent: OpticalCableComponent;

  parameters: MitraNetworkParameters;

  centralOfficeForm: FormGroup = this.formBuilder.group({});
  closureForm: FormGroup = this.formBuilder.group({});
  cableForm: FormGroup = this.formBuilder.group({});

  constructor(
    @Inject(MAT_DIALOG_DATA) private simulation: Simulation,
    private simulationService: SimulationService,
    private windowService: WindowService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    if (this.simulation.parameters) {
      this.parameters = deepCopy(this.simulation.parameters);
    } else {
      this.parameters = createSimulation({}).parameters;
    }
  }

  finish(): void {
    const simulation = createSimulation(this.simulation);
    simulation.parameters = this.parameters;
    this.simulationService.update(this.simulation.id, simulation)
      .subscribe(s => this.windowService.close(this));
  }

  newInternalCables($event: CabosAlimentacaoInterno) {
    this.opticalCableComponent.reloadInternalFeedingCables($event);

  }
}
